<template>
    <div class="border-bottom border-gray">
        <div
            class="
                d-flex
                align-items-center
                overflow-auto
                mx-n3
                mx-xl-n5
            "
        >
            <a
                v-for="(item, index) in items"
                :key="index"
                :href="item.url"
                :class="[
                    { 'is-active': item.active },
                    { 'is-italic': item.italic },
                    `
                        position-relative
                        d-flex
                        align-items-center
                        py-3
                        mx-3
                        mx-xl-5
                        text-nowrap
                        tab-item
                    `
                ]"
                type="button"
            >
                <span class="position-relative">
                    <span
                        v-if="item.attention"
                        class="
                            position-absolute
                            bg-danger
                            rounded-circle
                            message-notification
                        "
                    ></span>

                   {{ item.title }}
                </span>
            </a>
        </div>
    </div>
</template>

<script>
import UiIcon from './icon.vue';

export default {
    name: 'UiTabs',
    components: {
        UiIcon,
    },
    props: {
        items: {
            type: Array,
            default: () => [],
        },
    },
}
</script>

<style lang="scss" scoped>
    .tab-item {
        color: $dark;

        &::after {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 2px;
            content: '';
            background-color: $primary;
            opacity: 0;
            transition: 0.3s;
        }

        &.is-active,
        &:hover {
            color: $primary;

            &::after {
                opacity: 1;
            }
        }

        &.is-italic {
            font-style: italic;
        }
    }
</style>
